import { ProvisionedConstants, STAGE } from './constants';

export enum FeatureFlag {
  RdpIntegration = 'rdpIntegration',
  EmbeddedMode = 'embeddedMode',
}

const DEFAULT_FLAGS: Record<FeatureFlag, boolean> = {
  [FeatureFlag.RdpIntegration]: false,
  [FeatureFlag.EmbeddedMode]: false,
};

const STAGE_OVERRIDES: Partial<Record<STAGE, Partial<Record<FeatureFlag, boolean>>>> = {
  [STAGE.DEV]: { [FeatureFlag.RdpIntegration]: true, [FeatureFlag.EmbeddedMode]: true },
  [STAGE.BETA]: { [FeatureFlag.RdpIntegration]: true, [FeatureFlag.EmbeddedMode]: true },
  [STAGE.GAMMA]: { [FeatureFlag.RdpIntegration]: true, [FeatureFlag.EmbeddedMode]: true },
  [STAGE.PROD_NA]: { [FeatureFlag.RdpIntegration]: true, [FeatureFlag.EmbeddedMode]: false },
};

export const isFeatureEnabled = (flag: FeatureFlag): boolean => {
  const stage = ProvisionedConstants.STAGE as STAGE;
  return { ...DEFAULT_FLAGS, ...STAGE_OVERRIDES[stage] }[flag] ?? false;
};
